var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M114.992 0h-70C36.71.009 30 6.725 30 15.007v129.986C30 153.281 36.72 160 44.992 160h70c8.288 0 15.008-6.72 15.008-15.007V15.006C130 6.72 123.28 0 114.992 0ZM115 145H45V15h70v130Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 125,
  r: 10
})));

export default SvgMobile;